import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateBrandingSettingsQueries } from './useBrandingSettingsQuery';

export function useBrandingSettingsMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (brandingSettings: Api.BrandingSettings) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: async ({
			brandingSettings,
			impersonationContext,
		}: {
			brandingSettings: Api.BrandingSettings;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			const result = await userSession.webServiceHelper.callAsync<Api.BrandingSettings>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'accountProfile/branding',
					impersonationContext,
				}),
				'PUT',
				brandingSettings
			);
			return result;
		},
		onError,
		onSuccess: data => {
			// Invalidate the query to refetch fresh data
			invalidateBrandingSettingsQueries();
			onSuccess?.(data);
		},
	});
}
